import { useSelector } from 'react-redux';
import { OPLA_CRM_URL } from 'app_config';
import defaultLogo from 'assets/img/pebsteel.png';

// Reads a server-managed AppSetting value by key from redux (loaded once in
// MainLayout via getAppSettings). `fallback` is used before settings load or
// when the key is unset, so callers always get a usable value.
export const useAppSetting = (key, fallback = '') =>
  useSelector((state) => {
    const found = (state.app_settings?.data || []).find((s) => s.key === key);
    return found?.value || fallback;
  });

// APP_LOGO without sign-in: GET /api/v1/app_settings/logo redirects to the uploaded
// image (404 when none). For pages shown before the app settings are in redux
// (login, forgot password, public pages) — pair it with an onError fallback.
export const PUBLIC_LOGO_URL = `${process.env.REACT_APP_API_URL}/api/v1/app_settings/logo`;

// Company logo URL from the APP_LOGO AppSetting (server-managed attachment,
// same source the backend PDF views use), falling back to the bundled asset
// before settings load or when no logo has been uploaded.
export const useAppLogo = () =>
  useSelector((state) => {
    const found = (state.app_settings?.data || []).find((s) => s.key === 'APP_LOGO');
    return found?.logo_url || found?.value || defaultLogo;
  });

// Opla CRM web (deep-link) base + derived record URLs, sourced from the
// OPLA_CRM_URL AppSetting with the app_config constant as fallback.
export const useOplaUrls = () => {
  const base = useAppSetting('OPLA_CRM_URL', OPLA_CRM_URL);
  return {
    base,
    customer: `${base}/account`,
    contact:  `${base}/contact`,
    project:  `${base}/opportunity`,
  };
};
